import { Link } from 'react-router-dom'
import { TemplateVariableManager } from '../components/TemplateVariableManager'
import './TemplateVariablesHelp.css'

export function TemplateVariablesHelp() {
  return (
    <div className="template-variables-help-page">
      <div className="template-variables-help-header">
        <div>
          <Link to="/templates" className="back-link">
            ← Back to Templates
          </Link>
          <h1>Template Variables</h1>
          <p>
            Use these variables in Word templates to insert patient, system, and referral values.
          </p>
        </div>
      </div>

      <div className="template-variables-help-section">
        <h2>Syntax</h2>
        <p>Templates support variable replacement only.</p>
        <ul className="template-variables-help-list">
          <li>
            Use braces or plain paths: <code>{'{patient.firstName}'}</code> or{' '}
            <code>patient.firstName</code>.
          </li>
          <li>
            Nested fields use dot notation: <code>{'{patient.address.city}'}</code>.
          </li>
          <li>Missing values are rendered as <code>Not Available</code>.</li>
          <li>
            Consultation data is limited to <code>{'{consultation.id}'}</code> unless extended
            server-side.
          </li>
        </ul>
      </div>

      <div className="template-variables-help-section">
        <h2>Available Variables</h2>
        <TemplateVariableManager readOnly={true} defaultCollapsed={false} />
      </div>
    </div>
  )
}
